module.exports = __webpack_public_path__ + "static/img/pro--1.c183545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pro--1.png
// module id = 2+go
// module chunks = 1